import { MIN_INSTALLMENTS } from "@/constants/payroll-installments";

const CENTS_IN_UNIT: number = 100;

const NO_AMOUNT: number = 0;

export const toCents = (value: number): number =>
  Math.round(Number(value || NO_AMOUNT) * CENTS_IN_UNIT);

export const divideInstallments = (
  total: number,
  installments: number,
): number[] => {
  const totalCents: number = toCents(total);
  const baseCents: number = Math.floor(totalCents / installments);
  const values: number[] = Array.from(
    { length: installments },
    (): number => baseCents / CENTS_IN_UNIT,
  );

  values[installments - MIN_INSTALLMENTS] =
    (totalCents - baseCents * (installments - MIN_INSTALLMENTS)) / CENTS_IN_UNIT;

  return values;
};

export const sumInstallments = (values: number[]): number =>
  values.reduce(
    (accumulated: number, value: number): number => accumulated + toCents(value),
    NO_AMOUNT,
  ) / CENTS_IN_UNIT;

export const isSumExact = (values: number[], total: number): boolean =>
  values.reduce(
    (accumulated: number, value: number): number => accumulated + toCents(value),
    NO_AMOUNT,
  ) === toCents(total);

export const isDiscountableTotal = (total: number): boolean =>
  toCents(total) < NO_AMOUNT;
